const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Checkmark = require("./Checkmark");
const AssetsUtil = require("../util/AssetsUtil");

const styles = require("./styles/Checkbox.css");

const availableHoverFocusColors = ["yellow"];

module.exports = createReactClass({
	displayName: "Checkbox",

	propTypes: {
		className: PT.string,
		text: PT.oneOfType([PT.string, PT.element]).isRequired,
		onClick: PT.func.isRequired,
		isSelected: PT.bool.isRequired,
		tabIndex: PT.number,
		noTextHover: PT.bool,
		disabled: PT.bool,
		isErrored: PT.bool,
		isGray: PT.bool, // gray box (for white backgrounds)
		checkColor: PT.string,
		hoverColor: PT.string,
		textClass: PT.string,
		boxClass: PT.string,
		checkClass: PT.string,
		styleType: PT.oneOf(["office", "trainer", "demo", "custom"]),
	},

	getDefaultProps: function() {
		return {
			styleType: "office",
		};
	},

	onKeyPress: function(evt) {
		const {disabled, isSelected, onClick} = this.props;
		if (disabled) return;
		if (evt.which !== 13 && evt.which !== 32) {
			return;
		}
		evt.preventDefault();
		onClick(!isSelected);
	},

	handleClick: function() {
		const {disabled, isSelected, onClick} = this.props;
		if (disabled) return;
		onClick(!isSelected);
	},

	render: function() {
		const {
			text,
			isSelected,
			isErrored,
			tabIndex,
			className,
			noTextHover,
			disabled,
			isGray,
			checkColor,
			hoverColor,
			styleType,
		} = this.props;
		let textClass = this.props.textClass || "";
		let mainClass;
		const office = styleType === "office" || styleType === "demo";
		if (office) {
			if (styleType === "demo") {
				mainClass = styles.demo;
			} else {
				if (
					hoverColor &&
					_.includes(availableHoverFocusColors, hoverColor.toLowerCase())
				) {
					mainClass = styles[`${hoverColor.toLowerCase()}-active-color`];
				} else {
					mainClass = styles.mainOffice;
				}
			}
			mainClass += isGray ? " " + styles.blue : "";
		} else {
			mainClass = styles.mainTrainer;
		}
		if (isSelected) mainClass += " " + styles.selected;

		let checkClass = this.props.checkClass || styles.check;
		if (className) mainClass += " " + className;
		if (noTextHover) textClass += " " + styles.noTextHover;
		if (disabled) {
			mainClass += " " + styles.noPointer;
			checkClass += " " + styles.disabled;
		}

		const check = isSelected ? (
			<Checkmark
				className={checkClass}
				colorName={checkColor || "cyan"}
				isOffice={office}
			/>
		) : null;

		let boxEl;
		if (styleType === "custom") {
			boxEl = <div className={this.props.boxClass}>{check}</div>;
		} else if (office) {
			let boxClass = isGray ? styles.grayBox : styles.box;
			if (isErrored) boxClass += " " + styles.errored;
			boxEl = <div className={boxClass}>{check}</div>;
		} else {
			boxEl = (
				<div className={styles.trainerBox}>
					<img
						className={styles.boxImg}
						src={AssetsUtil.getButton("checkbox")}
					/>
					{check}
				</div>
			);
		}
		return (
			<div
				className={mainClass}
				onClick={this.handleClick}
				onKeyPress={this.onKeyPress}
				tabIndex={tabIndex}
			>
				{boxEl}
				<span className={textClass}>{text}</span>
			</div>
		);
	},
});
